module.exports = __webpack_public_path__ + "img/vue-logo.eb16ed7a.png";